import { render, staticRenderFns } from "./ExamPage.vue?vue&type=template&id=635a3650&scoped=true&"
import script from "./ExamPage.vue?vue&type=script&lang=js&"
export * from "./ExamPage.vue?vue&type=script&lang=js&"
import style0 from "./ExamPage.vue?vue&type=style&index=0&id=635a3650&prod&scoped=true&lang=scss&"
import style1 from "./ExamPage.vue?vue&type=style&index=1&id=635a3650&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635a3650",
  null
  
)

export default component.exports